var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_267:1787)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 42,
    r: 42,
    fill: "#187330"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5 19.5625C51.5 19.2518 51.2482 19 50.9375 19H35.1875C31.7702 19 29 21.7702 29 25.1875V56.6875C29 60.1048 31.7702 62.875 35.1875 62.875H57.6875C61.1048 62.875 63.875 60.1048 63.875 56.6875V34.5184C63.875 34.2077 63.6232 33.9559 63.3125 33.9559H53.1875C52.2555 33.9559 51.5 33.2004 51.5 32.2684V19.5625ZM53.1875 41.5C54.1195 41.5 54.875 42.2555 54.875 43.1875C54.875 44.1195 54.1195 44.875 53.1875 44.875H39.6875C38.7555 44.875 38 44.1195 38 43.1875C38 42.2555 38.7555 41.5 39.6875 41.5H53.1875ZM53.1875 50.5C54.1195 50.5 54.875 51.2555 54.875 52.1875C54.875 53.1195 54.1195 53.875 53.1875 53.875H39.6875C38.7555 53.875 38 53.1195 38 52.1875C38 51.2555 38.7555 50.5 39.6875 50.5H53.1875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.875 20.2918C54.875 19.8767 55.3084 19.6131 55.6314 19.8739C55.9035 20.0935 56.148 20.3508 56.3567 20.6415L63.1363 30.0868C63.2906 30.3018 63.1235 30.5809 62.8588 30.5809H55.4375C55.1268 30.5809 54.875 30.329 54.875 30.0184V20.2918Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_267:1787",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_267:1787"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_267:1787",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSave);
export default __webpack_public_path__ + "static/media/button_save.ac913dec.svg";
export { ForwardRef as ReactComponent };